module.exports = __webpack_public_path__ + "img/万达.f1fe2f9c.png";